import { GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME } from "~/Configurators/Linear/constants";
import { getDirtyParamName } from "~/Configurators/Linear/namingUtils";

import { type KmatType } from "~/Configurators/Linear/kmatType";

export const getGuidewayPieceDirtyParamName = (type: KmatType, kmatIndex: number, pieceIndex: number) => {
  return getDirtyParamName({
    key: GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME(pieceIndex),
    index: kmatIndex,
    type: type,
  });
};
